import { apiRequest } from "@/services/api-client";
import { UpdateBoxInput, UpdateBoxOutput } from "types/web-app";

export const updateBox = (input: UpdateBoxInput) =>
  apiRequest<UpdateBoxOutput>("/box/update", {
    method: "POST",
    body: JSON.stringify(input),
  });
